<template>
  <div class="publishLazad">
    <div class="center">
      <div class="desctext">{{ $t('other.a2887') }}</div>
      <div class="hgfb">
        <span>{{ $t('other.a288') }}：</span>
        <el-select size="mini" @change="getCategory()" v-model="shopId" :placeholder="$t('other.a50')">
          <el-option v-for="item in tiktokShops" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <span class="tips">{{ $t('other.a2881') }}</span>
      </div>
      <div>
        <span>{{ $t('other.a2882') }}:</span>
      </div>
      <div class="categoryWrapper">
        <div>
          <el-scrollbar class="boxwrapper">
            <div class="ingk" @click="addItem(firstItem, 1)" v-for="(firstItem, index) in categorylist" :key="index">
              <span class="name">{{ firstItem.localDisplayName }}</span>
              <span class="bkng"></span>
            </div>
          </el-scrollbar>
        </div>
        <div>
          <el-scrollbar class="boxwrapper">
            <div class="ingk" @click="addItem(firstItem, 2)" v-for="(firstItem, index) in categorylistTwo" :key="index">
              <span class="name">{{ firstItem.localDisplayName }}</span>
              <span class="bkng" v-show="firstItem.children"></span>
            </div>
          </el-scrollbar>
        </div>
        <div>
          <el-scrollbar class="boxwrapper">
            <div class="ingk" @click="addItem(firstItem, 3)" v-for="(firstItem, index) in categorylistThree"
              :key="index">
              <span class="name">{{ firstItem.localDisplayName }}</span>
              <span class="bkng" v-show="firstItem.children"></span>
            </div>
          </el-scrollbar>
        </div>
        <div>
          <el-scrollbar class="boxwrapper">
            <div class="ingk" @click="addItem(firstItem, 4)" v-for="(firstItem, index) in categorylistfour"
              :key="index">
              <span class="name">{{ firstItem.localDisplayName }}</span>
              <span class="bkng" v-show="firstItem.children"></span>
            </div>
          </el-scrollbar>
        </div>
        <div>
          <el-scrollbar class="boxwrapper">
            <div class="ingk" @click="addItem(firstItem, 5)" v-for="(firstItem, index) in categorylistfive"
              :key="index">
              <span class="name">{{ firstItem.localDisplayName }}</span>
              <span class="bkng" v-show="firstItem.children"></span>
            </div>
          </el-scrollbar>
        </div>
      </div>

      <div class="categoryDesc">
        <span class="categoryname">{{ $t('other.a2883') }}：</span>
        <span class="categoryname" v-for="(item, index) in categoryname" :key="index">
          {{ item }}
          <span v-show="item">/</span>
        </span>
      </div>

      <div class="footer">
        <el-button type="primary" @click="publish()">{{ $t('other.a2888') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import tiktokApi from "../../../api/moudles/tiktok";
export default {
  data() {
    return {
      tiktokShops: [],
      userId: null,
      shopId: null,
      categorylist: [],
      shopName: null,
      categorylistTwo: [],
      categorylistThree: [],
      categorylistfour: [],
      categorylistfive: [],
      categoryname: [],
      categoryId: []
    };
  },
  created() {
    let tiktopshops = JSON.parse(localStorage.getItem("userInfo")).tiktokShops;
    if (tiktopshops) {
      this.tiktokShops = tiktopshops.map(p => {
        return {
          label: p.shopName,
          value: p.shopId
        };
      });
    }

    let shops = JSON.parse(localStorage.getItem("userInfo"));
    this.userId = shops ? shops.userId : null;
    this.shopeeshops = shops ? shops.shopeeShops : [];
  },
  methods: {
    publish() {
      if (!this.categoryId[0]) {
        this.$message.warning(this.$t('other.a2885'));
        return;
      }
      let shopeeshops = JSON.parse(localStorage.getItem("userInfo"))
        .shopeeShops;
      let shopTarget = this.tiktokShops.find(item => item.value == this.shopId);
      let params = {
        shopId: this.shopId,
        shopName: shopTarget.label,
        categoryname: this.categoryname,
        categoryId: this.categoryId,
        country: null
      };

      localStorage.setItem("addLazada", JSON.stringify(params));
      //判断是否从是仓库单品发布
      if (this.$route.query.from == "single") {
        //仓库单品发布到tiktok
        this.$router.push({
          path: "/tiktokShop",
          query: {
            productId: this.$route.query.id,
            groupId: this.$route.query.groupId,
            type: "TikTok Shop"
          }
        });
      } else {
        //我已处理 发布到tiktok
        this.$router.push({
          path: "/addGoods",
          query: {
            productId: this.$route.query.id,
            groupId: this.$route.query.groupId,
            type: "TikTok Shop"
          }
        });
      }
    },
    addItem(item, num) {
      console.log(item, num);
      if (!item.children) {
        this.getCateDesc(item, num)
        return;
      }
      let category = item.children;
      let list = null;
      category
        ? (list = category.map(p => {
          return p.localDisplayName;
        }))
        : (list = []);
      if (list) {
        this.getTransferCategory(list).then(res => {
          console.log(res);
          category.forEach((p, index) => {
            p.localDisplayName = res[index];
          });

          item.children = category;
          this.getCateDesc(item, num)
        });
      }
    },

    getCateDesc(item, num) {
      if (num == 1) {
        this.categorylistTwo = item.children;
        this.categorylistThree = [];
        this.categorylistfour = [];
        this.$set(this.categoryname, num - 1, item.localDisplayName);
        this.$set(this.categoryId, num - 1, item.id);
      }
      if (num == 2) {
        this.categorylistThree = item.children;
        this.$set(this.categoryname, num - 1, item.localDisplayName);
        this.$set(this.categoryId, num - 1, item.id);
      }
      if (num == 3) {
        this.categorylistfour = item.children;
        this.$set(this.categoryname, num - 1, item.localDisplayName);
        this.$set(this.categoryId, num - 1, item.id);
      }

      if (num == 4) {
        this.categorylistfive = item.children;
        this.$set(this.categoryname, num - 1, item.localDisplayName);
        this.$set(this.categoryId, num - 1, item.id);
      }

      if (num == 5) {
        this.$set(this.categoryname, num - 1, item.localDisplayName);
        this.$set(this.categoryId, num - 1, item.id);
      }

      this.categoryname.forEach((p, index) => {
        if (index > num - 1) {
          this.$set(this.categoryname, index, null);
          this.$set(this.categoryId, index, null);
        }
      });
    },
    addLocalDisplayName(arr) {
      // 先判断传入的是否是数组，避免报错
      if (!Array.isArray(arr)) return []

      // 循环处理每一项
      return arr.map(item => {
        // 深拷贝，避免修改原始数据（重要！）
        const newItem = { ...item }

        // 为当前项添加 localDisplayName 字段
        // 这里可以自定义字段值规则，示例：使用name字段值
        newItem.localDisplayName = newItem.localName || ''

        // 判断是否有 children 且是数组，如果有则递归处理
        if (newItem.children && Array.isArray(newItem.children)) {
          newItem.children = this.addLocalDisplayName(newItem.children)
        }

        return newItem
      })
    },
    getCategory() {
      tiktokApi
        .getTikTokCategory({
          shopId: this.shopId,
          userId: this.userId
        })
        .then(res => {
          if (res.code === 200) {
            console.log("desc", res.data);
            // this.categorylist=res.data.children
            res.data.children = this.addLocalDisplayName(res.data.children);
            console.log(res.data.children)

            let category = res.data.children;
            let list = null;
            res.data.children
              ? (list = res.data.children.map(p => {
                return p.localDisplayName;
              }))
              : (list = []);
            console.log(list)
            console.log(category)
            if (list) {
              this.getTransferCategory(list).then(res => {
                console.log(res);
                category.forEach((p, index) => {
                  p.localDisplayName = res[index];
                });
                this.categorylist = category;
              });
            }
          } else {
            this.$message.warning(res.msg);
          }
        });
    },

    getTransferCategory(params) {
      return new Promise(resolve => {
        tiktokApi.getTransfer(params).then(res => {
          if (res.code === 200) {
            resolve(res.data.resultMap);
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@assets/scss/mixins";

.publishLazad {
  margin-top: $top_header_height;
  position: relative;

  .center {
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 1248px;
    // background-color: #eee;
    height: calc(100vh - 50px);

    .categoryDesc {
      background-color: #f7f8fa;
      margin-top: 20px;
      padding: 10px 0;
    }

    .categoryname {
      margin: 0 15px;
    }

    .desctext {
      font-size: 20px;
      color: #757575;
      padding: 10px 0;
    }

    .categoryWrapper {
      display: flex;
      margin-top: 15px;
      width: 1258px;
      overflow: hidden;
      overflow-x: scroll;
    }

    .footer {
      position: fixed;
      text-align: center;
      left: 0;
      right: 0;
      bottom: 0;
      padding: 15px 0;
      height: 40px;
      background-color: #eee;
    }

    .hgfb {
      padding: 20px 0;
    }

    .tips {
      color: red;
      margin-left: 20px;
    }

    .ingk {
      padding: 5px 0;
      cursor: pointer;
    }

    .ingk:hover {
      background-color: #edf7ff;
    }

    .bkng {
      float: right;
      width: 0;
      height: 0;
      border-top: 5px solid transparent;
      border-left: 5px solid #dadada;
      border-bottom: 5px solid transparent;
      position: relative;
      top: 6px;
      right: 15px;
    }

    .boxwrapper {
      width: 312px;
      height: 356px;
      overflow: hidden;
      border: 1px solid #dbdbdb;
    }

    .name {
      font-size: 12px;
      padding-left: 15px;
    }
  }

  /deep/ .el-scrollbar__wrap {
    overflow-x: hidden;
  }
}
</style>